import ProductImages from "./ProductImages"

import "./ProductImages.scss";

export * from "./ProductImages.types";

export { ProductImages };
